<template lang="pug" src="./html/SNCFLesPetitsServices-Body.pug"></template>

<script>
    import PortfolioItemBase from './PortfolioItemBase'

    export default {
      extends: PortfolioItemBase,
      mounted () {
        this.setupVideo('131884443', 'https://player.youku.com/embed/XMTgyMDc0NjYwOA==')
      }
    }
</script>

<style scoped>
    .awards h2 {
        color: #7F84B6;
    }
</style>
